import http from '@/http'

const URL = '/admin/marketplace'

// Recipients
export const getRecipients = (params) => http.get(`${URL}/recipients`, { params })

export const getRecipientByEvent = (eventId) => http.get(`${URL}/recipients/event/${eventId}`)

export const getRecipient = (id) => http.get(`${URL}/recipients/${id}`)

export const createRecipient = (data) => http.post(`${URL}/recipients`, data)

export const updateRecipient = (id, data) => http.put(`${URL}/recipients/${id}`, data)

export const deleteRecipient = (id) => http.delete(`${URL}/recipients/${id}`)

export const updateBankAccount = (id, data) => http.put(`${URL}/recipients/${id}/bank-account`, data)

export const updateTransferSettings = (id, data) => http.put(`${URL}/recipients/${id}/transfer-settings`, data)

// Balance
export const getBalance = (eventId) => http.get(`${URL}/events/${eventId}/balance`)

export const getBalanceOperations = (eventId, params) => http.get(`${URL}/events/${eventId}/balance/operations`, { params })

// Transfers
export const getTransfers = (eventId, params) => http.get(`${URL}/events/${eventId}/transfers`, { params })

export const createTransfer = (eventId, data) => http.post(`${URL}/events/${eventId}/transfers`, data)

export const getTransfer = (eventId, id) => http.get(`${URL}/events/${eventId}/transfers/${id}`)

// Anticipations
export const getAnticipations = (eventId, params) => http.get(`${URL}/events/${eventId}/anticipations`, { params })

export const simulateAnticipation = (eventId) => http.get(`${URL}/events/${eventId}/anticipations/simulate`)

export const getAnticipationLimits = (eventId, params) => http.get(`${URL}/events/${eventId}/anticipations/limits`, { params })

export const createAnticipation = (eventId, data) => http.post(`${URL}/events/${eventId}/anticipations`, data)

export const cancelAnticipation = (eventId, id) => http.post(`${URL}/events/${eventId}/anticipations/${id}/cancel`)

// Payment Settings
export const getPaymentSettings = () => http.get(`${URL}/payment-settings`)

export const updatePaymentSettings = (data) => http.put(`${URL}/payment-settings`, data)

// Dashboard
export const getDashboardKpis = (params) => http.get(`${URL}/dashboard/kpis`, { params })

export const getDashboardRevenueChart = (params) => http.get(`${URL}/dashboard/revenue-chart`, { params })

export const getDashboardTopTickets = (params) => http.get(`${URL}/dashboard/top-tickets`, { params })

export const getDashboardRecentTransactions = (params) => http.get(`${URL}/dashboard/recent-transactions`, { params })

export const getDashboardCategoryChart = (params) => http.get(`${URL}/dashboard/category-chart`, { params })

export const getDashboardPaymentMethodChart = (params) => http.get(`${URL}/dashboard/payment-method-chart`, { params })

export const getDashboardBalance = () => http.get(`${URL}/dashboard/balance`)
